// extracted by mini-css-extract-plugin
export default {"container":"style__container___O26Fs","input":"style__input___zFtR2","label":"style__label___n1Ijh","labelShrink":"style__labelShrink___O0CZA"};